
export default function HelpMapItemsService(gettext) {

    'ngInject';

    this.getModule = function () {

        var module = {
            "id": "map",
            "name": gettext("Map"),
            "description": gettext("The Map shows the location of all assets that have communicated a GPS location. Searching and filtering options are available to find the exact assets you are looking for."),
            "icon": "fas fa-question-circle",
            "priority": 1,
            "items": [{
                "orderid": 1.1,
                "itemid": "mapcontrols",
                "helpitemid": "map",
                "name": gettext("Map Controls"),
                "templateUrl": "map/map.controls.html"
            },
            {
                "orderid": 1.2,
                "itemid": "mapsearchpanel",
                "helpitemid": "map",
                "name": gettext("Search Panel & Results"),
                "templateUrl": "map/map.search.html"
            },
            {
                "orderid": 1.3,
                "itemid": "mappins",
                "helpitemid": "map",
                "name": gettext("Map Pins"),
                "templateUrl": "map/map.pins.html"
            },
            {
                "orderid": 1.4,
                "itemid": "mapassetinformation",
                "helpitemid": "map",
                "name": gettext("Asset Information"),
                "templateUrl": "map/map.asset.information.html"
            },
            ]
        };

        return module;
    };
}
